/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Api_Errors_Invalid_File_TypeInputs */

const nl_file_upload_api_errors_invalid_file_type = /** @type {(inputs: File_Upload_Api_Errors_Invalid_File_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit bestandstype wordt niet ondersteund.`)
};

/**

* @param {File_Upload_Api_Errors_Invalid_File_TypeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const file_upload_api_errors_invalid_file_type = /** @type {((inputs?: File_Upload_Api_Errors_Invalid_File_TypeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Api_Errors_Invalid_File_TypeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_file_upload_api_errors_invalid_file_type(inputs)
});
export { file_upload_api_errors_invalid_file_type as "file_upload.api_errors.invalid_file_type" }